import { useEffect, useRef } from 'react'

export default function useConfirmLeave(wait, eventPrefix = null) {
  const allowNavigationRef = useRef(false)

  const handleBeforeunload = (event) => {
    if (wait && !allowNavigationRef.current) {
      event.preventDefault()
      event.returnValue = ''
    }
  }

  useEffect(() => {
    if (!eventPrefix) return undefined

    const allowNavigationEvent = `${eventPrefix}:allow-navigation`
    const resetNavigationEvent = `${eventPrefix}:reset-navigation`

    const handleAllowNavigation = () => {
      allowNavigationRef.current = true
    }
    const handleResetNavigation = () => {
      allowNavigationRef.current = false
    }

    window.addEventListener(allowNavigationEvent, handleAllowNavigation)
    window.addEventListener(resetNavigationEvent, handleResetNavigation)

    return () => {
      window.removeEventListener(allowNavigationEvent, handleAllowNavigation)
      window.removeEventListener(resetNavigationEvent, handleResetNavigation)
    }
  }, [eventPrefix])

  useEffect(() => {
    if (wait) {
      window.addEventListener('beforeunload', handleBeforeunload)
    }
    return () => {
      window.removeEventListener('beforeunload', handleBeforeunload)
    }
  }, [wait])
}
